import { render, staticRenderFns } from "./AirportHandlers.vue?vue&type=template&id=485ee86a&scoped=true&"
import script from "./AirportHandlers.vue?vue&type=script&lang=js&"
export * from "./AirportHandlers.vue?vue&type=script&lang=js&"
import style0 from "./AirportHandlers.vue?vue&type=style&index=0&id=485ee86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ee86a",
  null
  
)

export default component.exports